<script>
export default {
  data(){
    return {
      ArtworkImages: [
        "6140baa1ca2c3_ofswxZFt1Z.jpeg.jpg",
        "5cda8b325430e_2DfTVMb6AO.jpg.jpg",
        "5e54e815ccfcf_cvMC3ExAMz.jpg.jpg",
        "5cda6f62a54e2_s5bHgIPmWV.jpg.jpg",
        "0FHVL-JM0CZ-R73LY-3B6JI.jpg",
        "5ce3a89ebc84e_q7xZbIGJv4.28.12%20PM.png.png",
        "5e54e8ea7d2db_En9VOYOh3o.jpeg.jpg",
        "QVE5Q-HZLPK-U5WNN-O1OKZ.png",
        "N9KC0-NJVNR-HFR3E-6JG41.jpg",
        "GW0QP-F0BMN-J6V5H-A1KHJ.png",
        "614fe6bfa58b9_a0qG0w4C4A.jpg.jpg",
        "5f280ad0db837_tG2PDiFq3O.01.39%20PM.png.png",
        "T00S0-6DYE3-Q12Y5-FPOJX.png",
      ],
      DefaultImages: [
        "3NDP5-8JTS8-I1V36-A3U61.jpg",
        "JWT18-TAJNV-48UG8-F027N.jpg",
        "SA9N0-R1QIO-QQ6JJ-TB9G2.jpg",
        "XLDKU-0OSOA-IZ68F-C7DJI.jpg",
        "5cd1483eec50b_VBXYyYF7lJ.jpg.jpg",
        "GMU3V-VM21M-D1J08-FEC1N.jpg",
        "WKE3K-V2HEA-7FHWB-AOS7D.jpg",
        "RMKWG-XPVD0-D7E5W-812OQ.jpg",
        "DSYVF-BROKP-30XR4-JDZ7E.jpg",
        "UTSSP-ETXII-094K6-LIVGV.jpg",
        "DGNNT-76PUN-2JTPB-PSYD2.jpg",
        "869PW-5TT1Z-YOCIC-VN3BD.jpg",
        "5cd1465383e54_bQ0G4MwMfs.jpg.jpg",
        "EQUFK-2C9CL-DV2RB-UN5A0.jpg",
        "47AO9-CUJJX-C60OR-BZTD5.jpg",
        "VL0HX-I8PMS-DLTJD-KCDGU.jpg",
        "FemaleArtwork.jpg",
        "VoiceoverArtwork2_1.jpg",
        "VoiceoverArtwork2_2.jpg",
        "VoiceoverArtwork2_3.jpg",
        "VoiceoverArtwork2_4.jpg",
        "VoiceoverArtwork2_5.jpg",
        "VoiceoverArtwork2_7.jpg",
        "VoiceoverArtwork3_1.jpg",
        "VoiceoverArtwork3_2.jpg",
        "VoiceoverArtwork3_3.jpg",
        "VoiceoverArtwork3_4.jpg",
        "VoiceoverArtwork3_5.jpg",
        "VoiceoverArtwork3_6.jpg",
        "LVXUT-W79CS-PXAAM-12KED.jpg",
        "5cd145f52533a_YhU6XeeB9i.jpg.jpg",
        "6UYMS-FFGWR-MR8Y7-B6WMQ.jpg",
        "20MW4-KBKSR-L4Q3K-9XJ9C.jpg",
        "SEVHW-59MIL-YTK8P-3JH77.jpg",
        "UDAOK-H0KWH-6D44O-JO3R3.jpg",
        "HWOMR-E4FBA-K0HO5-ERDEX.jpg",
        "QXOJM-4QCJN-UIJPQ-VJOED.jpg",
        "R1HNM-P53JN-SRJZR-ON90A.jpg",
        "JN7MS-BRR5B-WW41K-KLVM5.jpg",
        "9JOQX-SAB7X-TQPB8-NMIWT.jpg",
        "URWX9-MWGWP-SQPG5-Q34WW.jpg",
        "8S5Y3-6TY4W-PYICZ-8AULL.jpg",
        "SRL7C-2AFBP-LNZY4-UHDDT.jpg",
        "9RGSU-VQ5LC-ZDM91-N02EJ.jpg",
        "E2URL-7M9AY-MU8GE-9QZRD.jpg",
        "DLBW6-0YH13-W9IPB-KCRVR.jpg",
        "5cd147dd5e339_HCvrSiC8yV.jpg.jpg",
        "BL5TM-6027R-7G15K-1XKQJ.jpg",
        "2WOU9-2CO0K-L0EG0-8Y6H5.jpg",
        "5cd146fda72c0_9FxcTk0Fos.jpg.jpg",
        "5cd14ad0ec8c2_EUKXp6ZwqV.jpg.jpg",
        "7MBQF-SD9X2-KH6YG-JFKL4.jpg",
        "V6W8V-3XFVW-5VD7M-Y1FC5.jpg",
        "5cd14002b0abc_SXrfxNBHsG.jpg.jpg",
        "ZUV0T-H687M-YA064-38PVX.jpg",
        "RS5NG-KA1KI-I1OUZ-GNV81.jpg",
        "PTJRL-TIA3S-E8LJJ-68B2L.jpg",
        "TGGTN-KWV9R-TBOI6-XKJLL.jpg",
        "YEES7-CCCJA-6KWBN-DO3WX.jpg",
        "CYIS4-IH7Z4-W5497-7MIP3.jpg",
        "09KFA-N46PN-80YWE-N67R5.jpg",
        "5cd1399878547_yQyxBbHUTq.jpg.jpg",
        "KATJ0-ALIN7-PVDZL-A4F46.jpg",
        "Y7TBS-MQUTA-F68XY-DFGKF.jpg",
        "A4WWG-DL68X-0RTTX-K57XT.jpg",
        "VoiceoverArtwork3_3.jpg",
        "5cd149933bdcd_XDyRgLkrHU.jpg.jpg",
        "ZXM7V-D3M9Q-6Z6W4-MSPPW.jpg",
        "O744W-27055-V8LDX-UFNOJ.jpg",
        "E4W4G-01OK7-9ZY8R-OTA0A.jpg",
        "H40ET-4FA60-DZF9G-BEQYX.jpg",
        "QGNCO-3CQHN-2V8DS-EEQWG.jpg",
        "STMTT-ZJYNM-1EXRS-686M3.jpg",
        "9ML4E-ZOWXC-7WP0S-8CHY2.jpg",
        "6RMTB-RWO1H-ROGDB-32Z0K.jpg",
        "QQLYW-AOKPS-RRN04-BLIGF.jpg",
        "QVSII-0QFOE-3WJ4Y-JS1HQ.jpg",
        "GW05O-0WFE7-S9L6T-COE0O.jpg",
        "YOISR-UH64R-2D67V-INKIL.jpg",
        "Q1GH2-XOGY2-4XGIQ-OU20E.jpg",
        "BWRW4-G0NY8-VFDWU-709H7.jpg",
        "5cd147dd5e339_HCvrSiC8yV.jpg.jpg",
        "5P06V-4ISUS-KV25A-DSEJI.jpg",
        "8S5Y3-6TY4W-PYICZ-8AULL.jpg",
        "1GBMP-2KPI1-NX0ZM-6EPFQ.jpg",
        "09KFA-N46PN-80YWE-N67R5.jpg",
        "LZBZL-KUSMC-EU5KT-9RN7V.jpg",
        "84120-N2XXF-52HW9-5YGMQ.jpg",
        "R1HNM-P53JN-SRJZR-ON90A.jpg",
        "H5CXS-TWRDO-E5244-4ZTK4.jpg",
        "SL80O-OHEOT-JVJ8K-LLHSW.jpg",
        "60FX6-008EC-LQ87T-NB320.jpg",
        "RDIL1-CGWRH-J9BZH-MS6IF.jpg",
        "VK7BP-JK1YO-46GUA-ZV3FQ.jpg",
        "KHLPR-SXDAM-H9UAK-MXBGQ.jpg",
        "8F5IB-FO0Y4-KHBFG-QZY3E.jpg",
        "LCV1Y-VT5YM-XT754-WOOYN.jpg",
        "DD3B0-9PFSC-TELN6-RZIEU.jpg",
      ]
    }
  }
};
</script>
